import React from "react";
import StyleColourPicker from "./StyleColourPicker";
import {Checkbox} from "antd";
import {manageColours, getDefaultColour, getColourOnColour} from "./ManageColours";

const BaseStyles = props => {
    const {styles, updateStylesCallback} = props;
    const CORE_COLOURS = {
        MAIN: 'main',
        ON_MAIN: 'onMain',
        HEADING: 'heading',
        EMPH: 'emph'
    }
    const generateColours = (mainColour) => ({
        [CORE_COLOURS.ON_MAIN]: getColourOnColour(mainColour)
    });
    const {colours, updateColours, toggleGeneratedColours} = manageColours(
        styles,
        {
            [CORE_COLOURS.MAIN]: {name: `--cont-main-colour`, mainColour: true},
            [CORE_COLOURS.ON_MAIN]: {name: `--cont-on-main-colour`, autoGenerated: true},
            [CORE_COLOURS.HEADING]: {name: `--cont-heading-colour`},
            [CORE_COLOURS.EMPH]: {name: `--cont-emph-colour`}
        },
        generateColours,
        updateStylesCallback
    );

    return (
        <>
            <h4 className="margin-t--m">Colours</h4>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Main
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-main-colour`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.MAIN, {
                            [`--cont-main-colour`]: colour.hex(),
                            [`--cont-main-colour-RGB`]: colour.rgb().array()
                        })}
                    />
                </div>
            </div>
            <Checkbox checked={(colours[CORE_COLOURS.ON_MAIN].autoGenerated == true)}
                      onChange={(event) => toggleGeneratedColours(event.target.checked)}>
                Auto generated colours
            </Checkbox>
            <p className="ch-text-small margin-t--s">* Color can be auto-generated based on main color.</p>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    On main{colours && colours[CORE_COLOURS.ON_MAIN].autoGenerated ? " (auto)" : ""}*
                </div>
                <div className="flexJustifyEnd">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-on-main-colour`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.ON_MAIN, {
                            [`--cont-on-main-colour`]: colour.hex()
                        })}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Heading
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-heading-colour`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.HEADING, {[`--cont-heading-colour`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Emphasis
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-emph-colour`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-emph-colour`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 1
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-1`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-1`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 2
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-2`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-2`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 3
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-3`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-3`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 4
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-4`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-4`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 5
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-5`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-5`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 6
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-6`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-6`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 7
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-7`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-7`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 8
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-8`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-8`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 9
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-9`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-9`]: colour.hex()})}
                    />
                </div>
            </div>
            <div className="flexAlignCentre margin-t--s">
                <div className="flexMax">
                    Text colour 10
                </div>
                <div className="flex">
                    <StyleColourPicker
                        defaultValue={getDefaultColour(`--cont-custom-colour-10`, styles)}
                        onChange={(colour) => updateColours(CORE_COLOURS.EMPH, {[`--cont-custom-colour-10`]: colour.hex()})}
                    />
                </div>
            </div>
        </>
    )
}

export default BaseStyles;